export * from './one-column/one-column.layout';
export * from './two-columns/two-columns.layout';
export * from './three-columns/three-columns.layout';
export * from './manage-bookings/manage-bookings.layout';
export * from './manage-beverages/manage-beverages.layout';
export * from './manage-warranty/manage-warranty.layout';
export * from './manage-claim/manage-claim.layout';
export * from './manage-claimlist/manage-claimlist.layout';
export * from './manage-job_order/manage-job_order.layout';
